// Vendors
import classnames from 'classnames';

// Assets
import { ReactComponent as LogoSvg } from '../../assets/TxT-Lockup.svg';

// Styles
import './logo.scss';

const Logo = ({ className }) => (
  <span className={classnames('logo', className)} aria-label="TxT logo">
    <LogoSvg role="presentation" />
  </span>
);

export default Logo;
